module.exports = __webpack_public_path__ + "static/media/dabcorporate.1f0c98ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dabcorporate.svg
// module id = 1042
// module chunks = 0